import React from "react";

const Marquee = ({ items }) => {
  const repeat = [...items, ...items];
  return (
    <div className="marquee py-3 border-t border-b border-black/5" data-testid="marquee-ribbon">
      <div className="marquee-track">
        {repeat.map((it, i) => (
          <span key={i} className="font-label text-ink/70 mx-10 inline-flex items-center">
            <span className="w-1.5 h-1.5 bg-terracotta rounded-full mr-3" />
            {it}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
